<template>
  <donut-page-title
    title="Store settings"
    subtitle="Customize your reward store and keep track of fulfillment"
  />
</template>
